function toStageNumber(value: string | undefined): 1 | 2 | 3 | 4 | 5 | 6 | 7 {
  const n = Number(value);
  if (n >= 1 && n <= 7) return n as 1 | 2 | 3 | 4 | 5 | 6 | 7;
  return 1;
}

export const appConfig = {
  appName: import.meta.env.VITE_APP_NAME,
  version: import.meta.env.VITE_APP_VERSION,
  env: import.meta.env.VITE_APP_ENV,

  api: {
    // Not required — this game may have no backend interaction at all. Falls
    // back to an empty string; any code path that actually fires a request
    // (e.g. the leaderboard feature) will get a real request-time error
    // instead of crashing the whole app at boot for games that never call it.
    baseUrl: '' as string,
    timeout: Number(import.meta.env.VITE_API_TIMEOUT ?? 10000),
  },

  features: {
    devtools: import.meta.env.VITE_FEATURE_DEVTOOLS === 'true',
    analytics: import.meta.env.VITE_FEATURE_ANALYTICS === 'true',
  },

  encryption: {
    enabled: import.meta.env.VITE_ENCRYPTION_ENABLED === 'true',
    key: import.meta.env.VITE_PAYLOAD_AES_SECRET,
  },

  analytics: {
    id: import.meta.env.VITE_ANALYTICS_ID,
  },

  embed: {
    parentOrigin: import.meta.env.VITE_PARENT_ORIGIN,
  },

  socket: {
    // Not required — every consumer already prefers a `stageId` URL param over
    // this and only falls back to it when absent (see game.api.ts's getStageId,
    // useGameConfig.ts, etc.), so it shouldn't crash app boot on its own.
    stageId: import.meta.env.VITE_STAGE_ID ?? '',
    stageNumber: toStageNumber(((typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("stageNumber") : null) ?? import.meta.env.VITE_STAGE_NUMBER)),
  },
} as const;

export type AppConfig = typeof appConfig;
